import { render, staticRenderFns } from "./ModalDesvinculacaoTecnicoComponent.vue?vue&type=template&id=e54ea08a&scoped=true&lang=pug"
import script from "./ModalDesvinculacaoTecnicoComponent.vue?vue&type=script&lang=js"
export * from "./ModalDesvinculacaoTecnicoComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDesvinculacaoTecnicoComponent.vue?vue&type=style&index=0&id=e54ea08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54ea08a",
  null
  
)

export default component.exports